import {Injectable} from '@angular/core';
import {RadioCheckBoxEnum} from '../../../../common/radio.checkbox.enums';
import {Fourchette} from '../../models/Fourchette';
import {Oui_TypeOuiNonReservationMarche} from '../../models/Oui_TypeOuiNonReservationMarche';
import {TypeCPVClass} from '../../models/TypeCPVClass';
import {TypeFNSSimpleDescMarche} from '../../models/TypeFNSSimpleDescMarche';
import {TypeMarcheReserve} from '../../models/TypeMarcheReserve';
import {TypeMontantFourchette2} from '../../models/TypeMontantFourchette2';
import {TypeNatureMarcheChoix} from '../../models/TypeNatureMarcheChoix';
import {TypeObjCPV} from '../../models/TypeObjCPV';
import {TypeOuiNon} from '../../models/TypeOuiNon';
import {TypeOuiNonReservationMarche} from '../../models/TypeOuiNonReservationMarche';
import {SimpINControlNames} from '../../simpINControleNames';
import {AvisDataTransferService} from '../../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class NatureMarcheService {
  setValueFromControlName(value: any, attribut: any[]) {
    if (value && value != '') {
      attribut[attribut.length++] = value;
    }
  }

  constructor(private avisDataTransferService: AvisDataTransferService) {
  }

  getNatureMarche(controls, stepId): TypeFNSSimpleDescMarche {
    const natureMarche = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.natureMarche;
    if (stepId === 4) {
      const valeur = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepAtt_valeur');
      const fBasse = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepSep_Fourchette_SepAtt_valeurBasse');
      const fHaute = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepSep_Fourchette_SepAtt_valeurHaute');
      const devise = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeMontantFourchette2_SepAtt_devise');

      if (valeur) {
        natureMarche.valeurEstimee = new TypeMontantFourchette2();
        natureMarche.valeurEstimee.valeur = valeur;
        natureMarche.valeurEstimee.devise = devise;
        natureMarche.valeurEstimee.fourchette = null;
      } else if (fBasse && fHaute) {
        natureMarche.valeurEstimee = new TypeMontantFourchette2();
        natureMarche.valeurEstimee.fourchette = new Fourchette();
        natureMarche.valeurEstimee.fourchette.valeurBasse = fBasse;
        natureMarche.valeurEstimee.fourchette.valeurHaute = fHaute;
        natureMarche.valeurEstimee.devise = devise;
        natureMarche.valeurEstimee.valeur = null;
      } else { // cas forumlaire vide
        natureMarche.valeurEstimee = new TypeMontantFourchette2();
        natureMarche.valeurEstimee.valeur = 0;
        natureMarche.valeurEstimee.devise = "";
        natureMarche.valeurEstimee.fourchette = null;
      }

      natureMarche.dureeMois = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepAtt_dureeMois');
      natureMarche.intitule = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepAtt_intitule');
      natureMarche.description = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepAtt_description');
      natureMarche.lieuExecution = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepAtt_lieuExecution');

      natureMarche.codeCPV = new TypeObjCPV();

      natureMarche.codeCPV.objetPrincipal = new TypeCPVClass();
      natureMarche.codeCPV.objetPrincipal.classPrincipale = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale');

      natureMarche.tranches = new TypeOuiNon();
      if (controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_tranches_SepSep_TypeOuiNon_SepAtt_oui') == 'Oui') {
        natureMarche.tranches.non = null;
        natureMarche.tranches.oui = true;
      } else if (controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_tranches_SepSep_TypeOuiNon_SepAtt_oui') == 'Non') {
        natureMarche.tranches.non = true;
        natureMarche.tranches.oui = null;
      } else {
        natureMarche.tranches.non = null;
        natureMarche.tranches.oui = null;
      }

      natureMarche.natureMarche = new TypeNatureMarcheChoix();

      switch (controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeNatureMarcheChoix_SepAtt_travaux')) {
        case RadioCheckBoxEnum.travauxValue:
          natureMarche.natureMarche.travaux = '';
          natureMarche.natureMarche.services = null;
          natureMarche.natureMarche.fournitures = null;
          break;
        case RadioCheckBoxEnum.servicesValue:
          natureMarche.natureMarche.travaux = null;
          natureMarche.natureMarche.services = '';
          natureMarche.natureMarche.fournitures = null;
          break;
        case RadioCheckBoxEnum.fournituresValue:
          natureMarche.natureMarche.travaux = null;
          natureMarche.natureMarche.services = null;
          natureMarche.natureMarche.fournitures = '';
          break;
      }
      natureMarche.reservationMarche = new TypeOuiNonReservationMarche();
      natureMarche.reservationMarche.non = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeOuiNonReservationMarche_SepAtt_non');
      if (natureMarche.reservationMarche.non === 'Oui') {
        natureMarche.reservationMarche.non = null;
        natureMarche.reservationMarche.oui = new Oui_TypeOuiNonReservationMarche();
        natureMarche.reservationMarche.oui.reservationMarche = new TypeMarcheReserve();
        var nature = controls.get('_SepSep_Initial_SepSep_TypeFNSSimpleDescMarche_SepSep_TypeOuiNonReservationMarche_SepSep_Oui_TypeOuiNonReservationMarche_SepSep_TypeMarcheReserve_SepAtt_MarcheReserveRadio');
        natureMarche.reservationMarche.oui.reservationMarche.structureInsertion = nature === RadioCheckBoxEnum.structureInsertionValue ? '' : null;
        natureMarche.reservationMarche.oui.reservationMarche.entrepriseAdaptee = nature === RadioCheckBoxEnum.entrepriseAdapteeValue ? '' : null;
        natureMarche.reservationMarche.oui.reservationMarche.servicesSociaux = nature === RadioCheckBoxEnum.servicesSociauxValue ? '' : null;
      } else if (natureMarche.reservationMarche.non === 'Non') {
        natureMarche.reservationMarche.oui = null;
        natureMarche.reservationMarche.non = RadioCheckBoxEnum.emptyValue;
      } else {
        natureMarche.reservationMarche.oui = null;
        natureMarche.reservationMarche.non = null;
      }
    }

    if (stepId === 5) {
      natureMarche.lotsMarche = new TypeOuiNon();
      if (controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui') {
        natureMarche.lotsMarche.non = null;
        natureMarche.lotsMarche.oui = true;
      } else if (controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_SepSep_TypeOuiNon_SepAtt_oui') === 'Non') {
        natureMarche.lotsMarche.non = true;
        natureMarche.lotsMarche.oui = null;
      } else {
        natureMarche.lotsMarche.non = null;
        natureMarche.lotsMarche.oui = null;
      }
    }

    return natureMarche;
  }

}
